export default "__VITE_ASSET__ac173c32__"